import React from 'react';
import SafeSrcDocIframe from '../../customHooks/safe-src-doc-iframe';
import ProgramStateConst from '../../common/variables/ProgramStateConst';

function OfferPlayer(props) {

	let uid = "not_set";
	if (document.cookie.split(';').some((item) => item.trim().startsWith('uid='))) {
		uid = document.cookie.split('; ').find(row => row.startsWith('uid')).split('=')[1];
	}
	let scriptData = props.script;
	if(props.isVod === true) {
		if (props.isTester || (props.programState === ProgramStateConst.streaming && props.script) ) {
			scriptData = props.script.replace('&player=iijplayerdev','');
			scriptData = scriptData.replace('&player=iijplayer','');
		}
	}
	
	const html =
		`
			<style>
				html { overflow:hidden; }
				body { margin: 0; }
				.store-info { display:none; }
				#pl_programme_info_text { height: 0px; overflow:hidden; margin:0; padding:0;}
				.mt-frame { padding-right:0 !important; margin-right:0 !important;}
				.mt-frame ol { padding:1rem;}
				.mt-frame ol li p { margin:0;}
			</style>
			<div className="player__thumbnail" style="width:100%;padding-top:57.0%;overflow:hidden;position:absolute;">
			</div>
			<div id="msp_frame">
				<input id="pid" value="${uid}" type="hidden"></input>
				<input id="title" value="${props.muxPerformanceTitle}" type="hidden"></input>
		    	<script src="${scriptData}"></script>
			</div>

			<script>
				const resizeObserver = new ResizeObserver(entries => {
		  		for (const entry of entries) {
		    		let h = entry.target.clientHeight;
		      		let msp_frame = window.top.document.getElementById("msp_frame");
		      		msp_frame.style.height = h + "px";
		  		}
				});
				const target = document.querySelector('div');
				resizeObserver.observe(target);
			</script>
		`;
	const thumbnailURL = (props.performanceThumbnail === '') ? './assets/img/common/thumbnail-default.jpg' : props.performanceThumbnail ;

	return (
		<>
			<div className="player" id="fvPlayer">
				{props.isTester ?
					(
						props.script ?
						(
							<div id="msp_frame">
								<SafeSrcDocIframe id="myFrame" title="test-player" key={props.ifrm} srcDoc={'<body>' + html + '</body>'} sandbox="allow-same-origin allow-top-navigation allow-scripts allow-modals" width="100%" height="100%" frameBorder="0" marginHeight="0px" marginWidth="0px" />
							</div>
						) : (
							<div className="player__thumbnail">
								<img src={thumbnailURL} alt="Thumbnail" />
							</div>
						)
					) : (
						props.programState === ProgramStateConst.streaming && props.script ?
						(
							<div id="msp_frame">
								<SafeSrcDocIframe id="myFrame" title="test-player" key={props.ifrm} srcDoc={'<body>' + html + '</body>'} sandbox="allow-same-origin allow-top-navigation allow-scripts allow-modals" width="100%" height="100%" frameBorder="0" marginHeight="0px" marginWidth="0px" />
							</div>
						) : (
						<div className="player__thumbnail">
							<img src={thumbnailURL} alt="Thumbnail" />
						</div>
						)
					)
				}
			</div>
		</>
	);
}

export default OfferPlayer;